<template>
  <l-slider
    :items="comics"
    @finish="push"
  />
</template>
<script>
import webhook from '@/webhook'

const comics = [
  { url: require('@/assets/comics/info4-01.svg') },
]
export default {
  name: 'step56',
  setup(props, { root }) {
    const push = () => {
      webhook.reqMarkFirstTask()
      root.$router.replace('/education3/lesson2')
    }

    return {
      comics,
      push,
    }
  },
}
</script>
